import Content from "uxp-documentation/src/pages/uxp-api/reference-spectrum/Overview/About Spectrum UXP";
import * as React from 'react';
export default {
  Content,
  React
};